import { PlanningEntityType } from 'generated';
import { useSessionStorage } from 'usehooks-ts';
import { View } from '../enums';
import { isJSONString } from '../utils';

export type PlanningEntityTypePreference = {
  [key in View]: PlanningEntityType;
};

export default function usePlanningEntity(): [
  PlanningEntityTypePreference,
  (pref: PlanningEntityTypePreference) => void
] {
  const [planningEntityType, setPlanningEntityType] = useSessionStorage(
    'activityPlanningPlanningEntityType',
    'WORKPLACE'
  );
  const setPlanningEntity = (planningEntity: PlanningEntityTypePreference) => {
    const currentPlanningEntity = isJSONString(planningEntityType)
      ? (JSON.parse(planningEntityType) as PlanningEntityTypePreference)
      : {};
    setPlanningEntityType(
      JSON.stringify({
        ...currentPlanningEntity,
        ...planningEntity
      })
    );
  };
  return [
    isJSONString(planningEntityType) ? JSON.parse(planningEntityType) : {},
    setPlanningEntity
  ];
}
